export default function (injection, Vue, props = {}) {
    let scrollBarWidth;

    function fixDtd (s) {
        for (var k in s) {
            s[k.toUpperCase()] = s[k];
        }
        return s;
    }

    const block = fixDtd({
        figure: 1,
        address: 1,
        blockquote: 1,
        center: 1,
        dir: 1,
        div: 1,
        dl: 1,
        fieldset: 1,
        form: 1,
        h1: 1,
        h2: 1,
        h3: 1,
        h4: 1,
        h5: 1,
        h6: 1,
        hr: 1,
        isindex: 1,
        menu: 1,
        noframes: 1,
        ol: 1,
        p: 1,
        pre: 1,
        table: 1,
        ul: 1
    });
    const PROOF_DISABLED_MAP = {
        '千人计划': '您发布的稿件包含敏感词汇，根据国家及省有关规定，该稿件禁止发布，请对相关内容进行核查修订。如有疑问请致电020-83135072。'
    };

    const PROOF_MAP = {
        titleHTMLTpl: ` <div class="common-proof-title" style=" float: right;color: $TYPE_COLOR;width: auto;line-height: 36px;height: auto;text-align: center;overflow: hidden;padding: 0;margin: 7px 10px 7px 0;position: relative;font-size: 14px;">
                        <span class="common-proof-title__icon" style="font-family: cmsicon;cursor: pointer;font-size: 18px">$TYPE_ICON</span>
                        <span class="common-proof-title__text" style="font-weight: normal;font-size: 16px;">$TYPE_NUM</span>
                    </div>`,
        itemHtml: `<div class="common-proof-item with-$TYPE"
                         style="color: $TYPE_COLOR;position: relative;padding: 15px 10px 0 10px;line-height: 20px;font-size: 14px;box-sizing: border-box">
                        <span class="common-proof-item__icon" style="font-family: cmsicon; position: absolute;left: 10px;top: 14px;font-size: 16px">$TYPE_ICON</span>
                        <div class="common-proof-item__content" style="padding: 0 12px 0 24px;box-sizing: border-box">$TYPE_SOURCE</div>
                        $PROOF_TERM
                        <div class="common-proof-item__remark" style="color: #333; padding: 0 12px 0 24px;box-sizing: border-box">$TYPE_REMARK</div>
                    </div>
        `,
        itemTermHtml: `<div class="common-proof-item__term"  style="color: $TYPE_COLOR;position: relative; padding: 0 12px 0 24px;">
                            $TYPE_TERM
                            <span class="common-proof-item__term-icon $TERM-ICON" style="font-family: cmsicon;position: absolute; top: 2px;left: -10px;font-size: 36px">$TYPE_ICON</span>
                        </div>`,
        itemCmsTermHtml: `<div class="common-proof-item__term"  style="color: $TYPE_COLOR;position: relative; padding: 0 12px 0 24px;">
                            修改建议：$TYPE_TERM
                        </div>`,
        errorItemHtml: ``,
        doubtItemHtml: ``,
        tempWordItemHtml: ``,
        forbiddenIcon: `&#xe84a;`,
        forbiddenColor: '#ff4c2f',
        errorIcon: '&#xe71c;',
        doubtIcon: '&#xe71d;',
        tempWordIcon: '&#xe71e;',
        compterIcon: `&#xe724;`,
        personalIcon: `&#xe723;`,
        errorColor: '#ff4c2f',
        doubtColor: '#ee9123',
        tempWordColor: '#b525df',
        termColor: '#1ac66f'
    };

    const PROOF_MAP_CLIENT = {
        titleHTMLTpl: ` <div class="common-proof-title" style=" float: right;color: $TYPE_COLOR;width: auto;line-height: 36px;height: auto;text-align: center;overflow: hidden;padding: 0;margin: 7px 10px 7px 0;position: relative;font-size: 14px;">
                        <span class="common-proof-title__icon" style="font-family: cmsicon;cursor: pointer;font-size: 18px">$TYPE_ICON</span>
                        <span class="common-proof-title__text" style="font-weight: normal;font-size: 16px;">$TYPE_NUM</span>
                    </div>`,
        itemHtml: `<div class="common-proof-item with-$WORD_ERROR_TYPE"
                         style="font-family: cmsicon;position: relative;line-height: 20px;font-size: 14px;box-sizing: border-box">
                         $PROOF_OP
                         <span class="common-proof-item__link" style="display: inline-block;width: 100%;padding: 12px 10px 0 10px;box-sizing: border-box; text-decoration: none;color: #333" data-target="#$LINK_ID">
                        <div class="common-proof-item__content" style="box-sizing: border-box;display: flex;align-items: center;justify-content: space-between"><span style="color: $TYPE_COLOR;" class="common-proof-item__content-source">$TYPE_SOURCE</span><span style="display: $TYPE_SOURCE_LEN_DISPLAY">共 <span class="proof-count" style="color: $TYPE_COLOR;">$TYPE_SOURCE_LENGTH</span> 处</span></div>
                        $PROOF_TERM
                        <div class="common-proof-item__remark" style="color: #333; padding: 12PX 0;box-sizing: border-box;display: $TYPE_DISPLAY_REMARK">$TYPE_REMARK</div>
                        </span>
                        $PROOF_MORE_TEXT_HTML
                    </div>
        `,
        itemTermHtml: `<div class="common-proof-item__term"  style="padding: 12px 0; position: relative; ">
                            修改建议：$TYPE_TERM
                        </div>`,
        itemMoreTextHtml: `<div style="padding: 12px 10px;border-top:1px solid #ebecee;"> <div style="display: flex;box-sizing: border-box;align-items: center;justify-content: flex-start"><span style="color: #333;margin-right: 10px;font-family: cmsicon">&#xe777; 定位</span><span style="color: #999;font-size: 12px;flex:1">点击定位到文章相应处</span><span style="color: #999;cursor: pointer"  data-value="showAll" class="common-proof-item__show-all">全部 <span class="iconfont-2">&#xe699;</span></span></div> <div style="padding-top: 15px;" class="text-hide with-children">$PROOF_MORE_TEXT_HTML</div> </div>`,
        opHtml: `<div class="common-proof-item-op" data-value="$PROOF_OP_ID"><p class="op-item accept" data-value="accept">&#xe695;&nbsp;接受</p><p class="op-item ignore" data-value="ignore">&#xe6f7;&nbsp;忽略</p></div>`,
        errorItemHtml: ``,
        doubtItemHtml: ``,
        tempWordItemHtml: ``,
        errorIcon: '&#xe71c;',
        doubtIcon: '&#xe71d;',
        tempWordIcon: '&#xe71e;',
        compterIcon: `&#xe724;`,
        personalIcon: `&#xe723;`,
        errorColor: '#ff4c2f',
        doubtColor: '#ee9123',
        tempWordColor: '#8c54ff',
        termColor: '#1ac66f',

        errorBgColor: '#FABCC7',
        doubtBgColor: '#FFBF95',
        tempBgWordColor: '#d1bbff',
        termBgColor: '#1ac66f'
    };

    const getProofType = (item) => {
        if (item.error_type === 'CONTAIN_SENSITIVE' || item.error_type === 'CONTAIN_HINT' || (item.labels && item.labels.includes('PRIVACY'))) {
            return 'doubt';
        } else if (item.error_type === 'CONTAIN_TEMP_TAG') {
            return 'tempWord';
        } else {
            return 'error';
        }
    };

    const $div = document.createElement('div');
    let util = {
        checkIsEllipsis (dom) {
            const checkDom = dom.cloneNode();
            let parent, flag;
            checkDom.style.width = dom.offsetWidth + 'px';
            checkDom.style.height = dom.offsetHeight + 'px';
            checkDom.style.overflow = 'auto';
            checkDom.style.position = 'absolute';
            checkDom.style.zIndex = -1;
            checkDom.style.opacity = 0;
            checkDom.style.whiteSpace = 'nowrap';
            checkDom.innerHTML = dom.innerHTML;

            parent = dom.parentNode;
            parent.appendChild(checkDom);
            flag = checkDom.scrollWidth - checkDom.offsetWidth > 3;
            parent.removeChild(checkDom);
            return flag;
        },
        useDivFixText (text) {
            $div.innerHTML = text;
            return $div.innerText.replace(/</ig, '&lt;').replace(/>/ig, '&gt;');
        },
        formatProofTag (str, plainTxtTagObj = {}, tag, proofSignalStr = 'proof-signal-str') {
            plainTxtTagObj[tag] = [];
            let list = str.match(/<img.*?>/g);
            if (list && list.length > 0) {
                list.forEach((item, index) => {
                    let key = '#' + proofSignalStr + index + '#';
                    plainTxtTagObj[tag].push({
                        key: key,
                        value: item
                    });
                    str = str.replace(item, key);
                });
            }
            let linkList = str.match(/<a.*?>/g);
            if (linkList && linkList.length > 0) {
                linkList.forEach((item, index) => {
                    let key = '#link' + proofSignalStr + index + '#';
                    plainTxtTagObj[tag].push({
                        key: key,
                        value: item
                    });
                    str = str.replace(item, key);
                });
            }
            return str;
        },
        unFormatProofTag (str, plainTxtTagObj = {}, tag) {
            if (plainTxtTagObj[tag] && plainTxtTagObj[tag].length) {
                plainTxtTagObj[tag].forEach(item => {
                    str = str.replace(item.key, item.value);
                });
            }
            return str;
        },
        changeProofData (orgContent, result, withStyle = true, isnfcms = false) {
            orgContent = orgContent instanceof Array ? orgContent : [ orgContent ];
            orgContent.forEach((val, key) => {
                orgContent[key] = orgContent[key] || '';
                orgContent[key] = util.formatProofText((val || ''), result[key]);
                !withStyle && (orgContent[key] = util.removeStyleAttr(orgContent[key]));
            });
            const typeObj = {
                tempWord: [], doubt: [], error: [], forbidden: []
            };
            const typeHtmlObj = {
                error: [], doubt: [], tempWord: [], forbidden: []
            };
            const disabledList = [];

            result.forEach((list) => {
                if (list.length > 0) {
                    list.sort((a, b) => a.pos - b.pos);
                    list.forEach((item) => {
                        if (item.hasOwnProperty('tags')) {
                            item.labels = item.tags;
                        }
                        const labels = item.labels || [];
                        const forbiddenIdx = labels.find((e) => e === 'PUBLISH_FORBIDDEN');
                        if (labels && forbiddenIdx > -1) {
                            item['tag_copy'] = item.tag_copy || item.label_copy || [];
                            disabledList.push({
                                value: 'PUBLISH_FORBIDDEN',
                                text: item.tag_copy[forbiddenIdx]
                            });
                        }
                        if (item.error_type === 'CONTAIN_PRIVACY_PHONE') {
                            item.term = item.source.substr(0, 7) + '****';
                        }
                        if (item.error_type === 'CONTAIN_PRIVACY_ID') {
                            item.term = item.source.substr(0, 10) + '*******' + item.source.substr(17);
                        }
                        const proofType = getProofType(item);
                        typeObj[proofType].push(item);
                        typeHtmlObj[proofType].push(
                            PROOF_MAP.itemHtml.replace('$TYPE_COLOR', PROOF_MAP[`${ proofType }Color`])
                                .replace('$TYPE_ICON', PROOF_MAP[`${ proofType }Icon`])
                                .replace('$TYPE_SOURCE', item.source || '')
                                .replace('$TYPE_REMARK', item.remark || '')
                                .replace('$PROOF_TERM', (
                                    (proofType === 'error' || proofType === 'forbidden') && item.term) ?
                                    (isnfcms ? PROOF_MAP.itemCmsTermHtml : PROOF_MAP.itemTermHtml).replace('$TYPE_COLOR', PROOF_MAP.termColor)
                                        .replace('$TYPE_TERM', item.term)
                                        .replace('$TYPE_ICON',
                                            item.personal ? PROOF_MAP.personalIcon : PROOF_MAP.compterIcon) : ''
                                )
                        );
                    });
                }
            });

            let proofHtml = Object.values(typeHtmlObj).map(v => v.join('')).join('');

            let titleHtml = Object.keys(typeObj).map(key => {
                const value = typeObj[key];
                return PROOF_MAP.titleHTMLTpl.replace('$TYPE_COLOR', PROOF_MAP[`${ key }Color`])
                    .replace('$TYPE_ICON', PROOF_MAP[`${ key }Icon`])
                    .replace('$TYPE_NUM', value.length);
            }).join('');

            if (!withStyle) {
                proofHtml = util.removeStyleAttr(proofHtml);
                titleHtml = util.removeStyleAttr(titleHtml);
            }

            return {
                content: orgContent,
                doubtList: typeObj.doubt,
                tempWordList: typeObj.tempWord,
                errorList: typeObj.error,
                disabledList,
                titleHtml,
                proofHtml
            };
        },
        formatProofText (text, arr) {
            let posLimit = text.length + 1;
            arr = util.deepCopy(arr);
            arr.sort((a, b) => a.pos - b.pos);
            for (let index = arr.length; index > 0; index--) {
                let item = arr[index - 1];
                if (item.pos > -1 && item.end_pos && item.end_pos <= posLimit) {
                    let temp1 = text.slice(0, item.pos);
                    let temp2 = text.slice(item.pos, item.end_pos);
                    let temp3 = text.slice(item.end_pos);
                    let newTemp;
                    if (item.error_type === 'CONTAIN_PRIVACY_PHONE') {
                        item.term = item.source.substr(0, 7) + '****';
                    }
                    if (item.error_type === 'CONTAIN_PRIVACY_ID') {
                        item.term = item.source.substr(0, 10) + '*******' + item.source.substr(17);
                    }
                    if (item.error_type === 'CONTAIN_SENSITIVE' || item.error_type === 'CONTAIN_HINT' || (item.labels && item.labels.includes('PRIVACY'))) {
                        newTemp = `<span class='common-proof-doubt' style='color: ${ PROOF_MAP.doubtColor }'>${ temp2 }</span>`;
                    } else if (item.error_type === 'CONTAIN_TEMP_TAG') {
                        newTemp = `<span class='common-proof-tempWord' style='color: ${ PROOF_MAP.tempWordColor }'>${ temp2 }</span>`;
                    } else {
                        const style = item.error_type === 'SHOULD_NOT_TOGETHER' ? '' : 'line-through';
                        newTemp = `<span class='common-proof-error' style='color: ${ PROOF_MAP.errorColor } ;text-decoration: ${ style }'>${ temp2 }</span>`;
                        if (item.term) {
                            newTemp += `<span class='common-proof-correct' style='color: ${ PROOF_MAP.termColor }'>(${ item.term })</span>`;
                        }
                    }
                    text = temp1 + newTemp + temp3;
                    posLimit = item.pos;
                }
            }
            text = text.replace(/\n/g, '<br>');
            return text;
        },
        removeStyleAttr (str) {
            if (!str) {
                return '';
            }
            return str.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/ig, '');
        },
        noAuthPromise (data, status = 1205) {
            return Promise.reject({
                errcode: status,
                errmessage: '你没有该站点访问权限',
                data: data
            });
        },
        handleOrgAppList (params) {
            const {
                appList = [],
                visibleAppList = [],
                organization: website,
                sourceApp,
                hasDisabled
            } = params;

            const appListMap = {};
            appList.forEach(v => {
                appListMap[v.id] = v;
            });
            let result = visibleAppList.map(v => {
                const {group, app_display, app} = v;
                const authApp = appListMap[app.id];
                const hashIdx = app.link.indexOf('#');
                const queryIdx = app.link.lastIndexOf('?');

                const data = {
                    appId: app.id,
                    id: app_display.id,
                    disabled: !authApp,
                    img: app_display.img,
                    group_name: app_display.name,
                    name: app_display.name,
                    link: `${ app.link }${ queryIdx > hashIdx ? '&' : '?' }source_app=${ sourceApp }`,
                    type: group.type,
                    intro: app_display.intro,
                    sort: group.sort || Infinity,
                    siteId: website.siteId ? website.siteId : 0,
                    orgId: website.id,
                    group_id: group.id,
                    group,
                    app_display,
                    app
                };

                // 1站点  0单位
                if (group.classes === 1 && authApp && !data.siteId) {
                    data.disabled = !authApp.site_list || !authApp.site_list.length;
                    data.siteId = data.disabled ? 0 : authApp.site_list[0].id;
                }

                data.enable = !data.disabled;

                data.link = data.link.replace('{$SID}', data.siteId)
                    .replace('{$OID}', website.id)
                    .replace('{$AID}', website.service_area_id);

                return data;
            });

            result.sort((a, b) => a.sort - b.sort);

            if (!hasDisabled) {
                result = result.filter(v => !v.disabled);
            }
            return result;
        },
        handleSiteAppList (applist, website, ucurl, source_app) {
            if (!applist || !applist.length) {
                return [];
            }
            const {id, service_area_id, org_id} = website;
            applist = util.deepCopy(applist);
            applist = applist.filter(v => v.hasOwnProperty('disabled') ? !v.disabled : v.enable);
            applist.forEach((v, i) => {
                if (!v.hasOwnProperty('enable')) {
                    const splitArray = v.img.split('.');
                    v.img = !ucurl ? undefined : `${ ucurl }${ splitArray[0] }_new.${ splitArray[1] }`;
                    if (v.link.indexOf('?') !== -1) {
                        v.link = `${ v.link }&source_app=${ source_app }`;
                    } else {
                        v.link = `${ v.link }?source_app=${ source_app }`;
                    }
                    v.link = v.link.replace('{$SID}', id).replace('{$AID}', service_area_id).replace('{$OID}', org_id);
                } else {
                    const {group, app_display, app, enable} = v;
                    const hashIdx = app.link.indexOf('#');
                    const queryIdx = app.link.lastIndexOf('?');
                    const data = {
                        id: group.id,
                        disabled: !enable,
                        img: app_display.img,
                        group_name: app_display.name,
                        name: app_display.name,
                        link: `${ app.link }${ queryIdx > hashIdx ? '&' : '?' }source_app=${ source_app }`,
                        type: group.type,
                        intro: app_display.intro,
                        sort: group.sort
                    };
                    data.link = data.link.replace('{$SID}', id).replace('{$AID}', service_area_id).replace('{$OID}', org_id);
                    applist[i] = data;
                }
            });
            return applist;
        },
        getServiceList (sites, addMore) {
            if (sites[0] && ('sort' in sites[0])) {
                sites = sites.sort((a, b) => a.sort - b.sort);
            }
            sites = injection.util.deepCopy(sites);
            let serviceList = {}, more = true;
            const siteMap = {};
            sites.forEach(v => {
                let {service_area_id, service_area_sort = Infinity, service_area_name, id} = v;
                service_area_sort = service_area_sort === null ? Infinity : service_area_sort;
                service_area_id = service_area_id || -1;
                service_area_name = service_area_name || '未配置';
                siteMap[id] = v;
                const temp = {
                    value: service_area_id,
                    text: service_area_name,
                    sort: service_area_sort,
                    children: addMore ? [ {
                        id: `z${ service_area_id }`,
                        value: `z${ service_area_id }`,
                        sort: -1,
                        text: `${ service_area_name.includes('省直') ? '全省' : service_area_name }总览`,
                        service_area_id, service_area_name
                    } ] : []
                };
                serviceList[service_area_id] = serviceList[service_area_id] || temp;
                serviceList[service_area_id].children.push({
                    ...v,
                    value: v.id,
                    text: v.name,
                });
            });
            serviceList = Object.values(serviceList);
            more = serviceList.length !== 1;

            if (!more) {
                serviceList = serviceList[0].children;
            } else {
                serviceList.sort((v1, v2) => {
                    if (v1.hasOwnProperty('sort')) {
                        return v1.sort - v2.sort;
                    } else {
                        return v1.value === -1 ? 1 : v1.value - v2.value;
                    }
                });
            }

            return {
                more,
                map: siteMap,
                serviceList: serviceList
            };
        },
        getAuthGroups (auths) {
            if (!auths) {
                return;
            }
            return auths.split('-').map(v => {
                return util.validate.numberic(v) ? Number(v) : v;
            });
        },
        request (url = window.location.href, withHash = false) {
            let map = {}, j,
                i = url.indexOf('?'),
                m = url.indexOf('#');
            if (i < 0) {
                return map;
            }
            const hashIdx = m;
            j = m > 0 ? (url.slice(i + 1, m)) : j = url.slice(i + 1);
            m = j.split('&');
            for (i = 0; i < m.length; i++) {
                j = m[i].indexOf('=');
                if (j <= 0) {
                    continue;
                }
                map[m[i].slice(0, j)] = decodeURIComponent(m[i].slice(j + 1));
            }
            if (withHash) {
                j = url.slice(hashIdx + 1, url.length);
                j = util.request(j);
                Object.assign(map, j);
            }
            return map;
        },
        statistics (appid, siteid) {
            const $body = document.querySelector('body');
            const $img = document.createElement('img');
            const load = () => {
                $img.removeEventListener('load', load);
                $body.removeChild($img);
            };
            $img.addEventListener('load', load, true);
            $img.src = `http://statistics.gd.gov.cn/visit/visit?appid=${ appid }&site=${ siteid }`;
            $body.appendChild($img);
        },
        goBack (fn) {
            if (window.history.length === 1) {
                fn && fn();
            } else {
                window.history.go(-1);
            }
        },
        uniqueArray (arr) {
            return [ ...new Set(arr) ];
        },
        randomColor () {
            return `#${ Math.floor(Math.random() * 0xffffff).toString(16).padEnd(6, '0') }`;
        },
        random11Str () {
            return Math.random().toString(36).substring(2);
        },
        randomId (prefix = 'id') {
            return `${ prefix }_${ Number.parseInt(Math.random() * 100000000000000000) }`;
        },
        randomNumber (ws = 1000000000000, fs) {
            return Math.ceil(Math.random() * Math.pow(10, ws)) * (fs ? -1 : 1);
        },
        checkIEVersion () {
            const ua = window.navigator.userAgent;

            const msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            const trident = ua.indexOf('Trident/');
            if (trident > 0) {
                const rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }
        },
        isIE () {
            return (!!window.ActiveXObject || 'ActiveXObject' in window);
        },
        deepCopy (data) {
            return JSON.parse(JSON.stringify(data));
        },
        HTMLEncode (text) {
            function getCharEntity (ch) {
                var charEntities = {
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    '\x00': '&#0;',
                    '\'': '&#39;',
                    '"': '&#34;',
                    '`': '&#96;'
                };
                return charEntities[ch] || (charEntities[ch] = '&#' + ch.charCodeAt(0) + ';');
            }

            var isHtml = /[\x00`><\"'&]/;
            var htmlEncode = /[\x00`><"'&]/g;
            return text != null ? isHtml.test(text) && ('' + text).replace(htmlEncode, getCharEntity) || text : '';
        },
        HTMLEncodeByDiv (str) {
            $div.innerHTML = '';
            $div.innerText = str;
            return $div.innerHTML;
        },
        HTMLDecode (text) {
            const temp = document.createElement('div');
            temp.innerHTML = text;
            return temp.innerText || temp.textContent;
        },
        getBlobBydataURI (dataURI, type) {
            let binary = window.atob(dataURI);
            let array = [];
            for (let i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new window.Blob([ new Uint8Array(array) ], {type: type});
        },
        clearHTML (str, rep = '') {
            return str.replace(/<[^>]*>|<\/[^>]*>/gm, rep);
        },
        clearSpace (val) {
            if (!val || typeof val !== 'string') {
                return val;
            }
            return val.replace(/\ +/g, '').replace(/[ ]/g, '').replace(/[\r\n]/g, '');
        },
        cleanText (str) {
            if (typeof str === 'number') {
                return str;
            } else if (!str) {
                return '';
            }
            str = str.replace(/<\/?[^>]*>/gm, ''); //去除HTML tag
            str = str.replace(/[ | ]*\n/gm, '\n'); //去除行尾空白
            str = str.replace(/\n[\s| | ]*\r/gm, '\n'); //去除多余空行
            str = str.replace(/^[\s]+|[\s]+$/gm, '');//去掉全角半角空格
            str = str.replace(/[\r\n]/gm, '');//去掉回车换行
            return str.trim();
        },
        mkurl (url, args, isRestful) {
            let fi = true;
            if (isRestful) {
                args = args.join('/');
                if (url[url.length - 1] === '/') {
                    url = `${ url }${ args }`;
                } else {
                    url = `${ url }/${ args }`;
                }
            } else {
                if (args) {
                    for (let i in args) {
                        if (fi) {
                            fi = false;
                            url += '?' + i + '=' + encodeURIComponent(args[i]);
                        } else {
                            url += '&' + i + '=' + encodeURIComponent(args[i]);
                        }
                    }
                }
            }
            return url;
        },
        highLight (content, keyword, color = '#008afe') {
            if (util.validate.isEmpty(keyword)) {
                return content;
            } else if (util.validate.isEmpty(content)) {
                return '';
            }
            let replaceStr = `<span style='color:${ color }'>$1</span>`;
            let reg = new RegExp('(' + keyword + ')', 'ig');
            return content.replace(reg, replaceStr);
        },
        highLight4Join (content, keyword, color = '#008afe') {
            if (util.validate.isEmpty(keyword)) {
                return content;
            } else if (util.validate.isEmpty(content)) {
                return '';
            }
            let replaceStr = `<span style='color:${ color }'>$1</span>`;
            let reg = new RegExp('(' + keyword.split('').join('|') + ')', 'ig');
            return content.replace(reg, replaceStr);
        },
        getScrollBarWidth () {
            if (scrollBarWidth !== undefined) return scrollBarWidth;
            const outer = document.createElement('div');
            outer.style.visibility = 'hidden';
            outer.style.width = '100px';
            outer.style.position = 'absolute';
            outer.style.top = '-9999px';
            document.body.appendChild(outer);

            const widthNoScroll = outer.offsetWidth;
            outer.style.overflow = 'scroll';

            const inner = document.createElement('div');
            inner.style.width = '100%';
            outer.appendChild(inner);

            const widthWithScroll = inner.offsetWidth;
            outer.parentNode.removeChild(outer);
            scrollBarWidth = widthNoScroll - widthWithScroll;

            return scrollBarWidth;
        },
        resetQuot (str, noBr) {
            if (!str) {
                return str;
            }
            let changeStr = '';
            changeStr = str.replace(/&amp;/g, '&');
            changeStr = changeStr.replace(/&nbsp;/g, ' ');
            changeStr = changeStr.replace(/&lt;/g, '<');
            changeStr = changeStr.replace(/&gt;/g, '>');
            !noBr && (changeStr = changeStr.replace(/\r\n/g, '<br>'));
            changeStr = changeStr.replace(/&quot;/g, '"');
            changeStr = changeStr.replace(/&ldquo;/g, '“');
            changeStr = changeStr.replace(/&rdquo;/g, '”');
            changeStr = changeStr.replace(/&rdquo;/g, '”');
            changeStr = changeStr.replace(/&lsquo;/g, '‘');
            changeStr = changeStr.replace(/&rsquo;/g, '’');
            return changeStr;
        },
        getPlainTxt (html) {
            if (typeof html !== 'string' || !html) {
                return '';
            }
            var reg = new RegExp('\u200B', 'g');
            if (html.indexOf('<iframe') > -1) {
                var _div = document.createElement('div');
                _div.innerHTML = html;
                var targets = _div.querySelectorAll('iframe');
                [].forEach.call(targets, function (ifr) {
                    ifr.parentNode.removeChild(ifr);
                });
                html = _div.innerHTML;
            }
            html = html
                .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, '\n')
                .replace(/<br\/?>/gi, '\n')
                .replace(/<[^>/]+>/g, function (a) {
                    if (a.indexOf('<video') === 0) {
                        return a;
                    }
                    return '';
                })
                .replace(/(\n)?<\/([^>]+)>/g, function (a, b, c) {
                    if (c === 'video') {
                        return '</video>';
                    }
                    return block[c] ? '\n' : b ? b : '';
                });
            //取出来的空格会有c2a0会变成乱码，处理这种情况\u00a0
            return html
                .replace(reg, '')
                .replace(/\u00a0/g, ' ')
                .replace(/&nbsp;/g, ' ');
        },
        getIncreaseId () {
            window.__increase_id__ = window.__increase_id__ || 0;
            window.__increase_id__ += 1;
            return `${ window.__increase_id__ }`;
        },
        setIncreaseSeed (seed) {
            window.__increase_id__ = (seed += 1);
        },
        validator () {
            return {
                isFunction (fn) {
                    return Object.prototype.toString.call(fn) === '[object Function]';
                },
                isEmpty (obj) {
                    if (Array.isArray(obj)) {
                        return !obj.length;
                    } else if (typeof obj === 'object') {
                        return !obj;
                    } else if (obj === undefined) {
                        return true;
                    } else if (typeof obj === 'string' && !obj.length) {
                        return true;
                    }
                    return false;
                },
                isNumeric (obj) {
                    return !isNaN(parseFloat(obj)) && isFinite(obj);
                },
                numeric (obj) {
                    return this.isNumeric(obj);
                },
                numberic (obj) {
                    return this.isNumeric(obj);
                },
                email (obj) {
                    return /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z]{2,30}$/.test(obj);
                },
                chinese (obj) {
                    return /^[\u4e00-\u9fa5]{0,}$/.test(obj);
                },
                english (obj) {
                    return /^[a-zA-Z]+$/.test(obj);
                },
                url (obj) {
                    return /(^#)|(^http(s*):\/\/[^\s]+\.[^\s]+)/.test(obj);
                },
                idcard (obj) {
                    return /(^\d{15}$)|(^\d{17}(x|X|\d)$)/.test(obj);
                },
                mobile (obj) {
                    return /^1(2|3|4|5|6|7|8|9)[0-9]\d{8}$/.test(obj);
                },
                document (obj) {
                    return /\.doc(x?)$|\.xls(x?)$|\.ppt(x?)$|\.wps$|\.pdf$|\.txt$/i.test(obj);
                },
                image (obj) {
                    return /\.png|\.jpg$|\.jpeg$|\.gif$/i.test(obj);
                },
                video (obj) {
                    return /\.wmv$|\.avi$|\.mkv$|\.rm$|\.mov$|\.mp4$|\.rmvb$/i.test(obj);
                },
                audio (obj) {
                    return /\.mp3/i.test(obj);
                },
                archive (obj) {
                    return /\.rar$|\.zip$|\.7z$|\.gzip$|\.tar$|\.iso$/i.test(obj);
                },
                english_or_numeric: function (str) {
                    return /^[A-Za-z0-9]+$/g.test(str);
                },
                unified_social_credit_code: function (str) {
                    return str.length === 18 && util.validate.english_or_numeric(str);
                }
            };
        },
        browser () {
            const u = navigator.userAgent;
            return {
                trident: u.indexOf('Trident') > -1,
                presto: u.indexOf('Presto') > -1,
                webKit: u.indexOf('AppleWebKit') > -1,
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1,
                mobile: !!u.match(/AppleWebKit.*Mobile.*/),
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
                android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
                iPhone: u.indexOf('iPhone') > -1,
                iPad: u.indexOf('iPad') > -1,
                webApp: u.indexOf('Safari') === -1,
                weixin: u.indexOf('MicroMessenger') > -1,
                qq: u.match(/\sQQ/i) === ' qq'
            };
        },
        copyToClipboard (content, callback) {

            var textarea = document.createElement('textarea');
            textarea.style.position = 'absolute';
            textarea.style.left = '-1000px';
            textarea.style.top = '-1000px';
            textarea.value = content;
            textarea.readOnly = true;
            document.body.appendChild(textarea);

            textarea.select();
            textarea.setSelectionRange(0, textarea.value.length);

            var result = false;
            try {
                result = document.execCommand('copy');

                callback && callback();
            } catch (e) {
            }
            document.body.removeChild(textarea);
            textarea = null;
        },
        // 单机版校对结果弹窗
        getDomPath (event) {
            let path = event.path || (event.composedPath && event.composedPath());
            if (!path || !path.length) {
                path = this.getParentDom(event.target);
            }
            return path;
        },
        changeProofDataClient (orgContent, result, withStyle = true, filterOpt = []) {
            result = util.deepCopy(result);
            filterOpt = filterOpt.join(',');
            orgContent = util.deepCopy(orgContent);
            orgContent = orgContent instanceof Array ? orgContent : [orgContent];
            orgContent.forEach((val, key) => {
                const {text, result: arry} = util.formatProofTextClient(val, result[key], key, filterOpt);
                orgContent[key] = text;
                result[key] = arry;
                !withStyle && (orgContent[key] = util.removeStyleAttr(orgContent[key]));
            });
            const typeObj = {
                error: [], doubt: [], tempWord: [],
            };
            const typeHtmlObj = {
                error: [], doubt: [], tempWord: [],
            };
            let allWords = [];
            result.forEach((list) => {
                if (list && list.length > 0) {
                    list.sort((a, b) => a.pos - b.pos);
                    allWords = [...allWords, ...list];
                }
            });
            const map = {};
            allWords.sort((a, b) => a.pos - b.pos);
            allWords.forEach((v) => {
                const key = `${v.error_type}_${v.source}`;
                const item = map[key];
                if (!item) {
                    map[key] = {
                        pos: v.pos,
                        error_type: v.error_type,
                        hint: v.hint,
                        linkIds: [v.linkId],
                        remark: v.remark,
                        source: v.source,
                        source_around: v.source_around,
                        end_pos: v.end_pos,
                        can_be_list: v.can_be_list,
                        term: v.term,
                        label: v.label,
                        tags: v.tags || []
                    };
                } else {
                    item.linkIds.push(v.linkId);
                }
            });
            Object.values(map).sort((a, b) => a.pos - b.pos).forEach((item) => {
                if (item.error_type === 'CONTAIN_PRIVACY_PHONE') {
                    item.term = item.source.substr(0, 7) + '****';
                }
                if (item.error_type === 'CONTAIN_PRIVACY_ID') {
                    item.term = item.source.substr(0, 10) + '*******' + item.source.substr(17);
                }
                const proofType = getProofType(item);
                typeObj[proofType].push(item);
                let html = PROOF_MAP_CLIENT.itemHtml.replace(/\$TYPE_COLOR/g, PROOF_MAP_CLIENT[`${proofType}Color`])
                    .replace('$TYPE_ICON', PROOF_MAP_CLIENT[`${proofType}Icon`])
                    .replace('$TYPE_SOURCE', item.tags && item.tags.includes('PUBLISH_FORBIDDEN_MEDIA') ? '<span class="iconfont-2" style="font-size:22px;position:relative;top:3px;left:-4px;">&#xe84a;</span>' + item.source : (item.source || ''))
                    .replace('$TYPE_SOURCE_LENGTH', `${item.linkIds.length}` || '1')
                    .replace('$TYPE_SOURCE_LEN_DISPLAY', item.linkIds.length === 1 ? 'none' : 'block')
                    .replace('$WORD_ERROR_TYPE', item.error_type)
                    .replace('$PROOF_TERM', (
                        (proofType === 'error' || proofType === 'doubt') && item.term) ?
                        PROOF_MAP_CLIENT.itemTermHtml.replace('$TYPE_TERM', (item.label && item.label.includes('PRIVACY')) ? item.remark : item.term)
                            .replace('$TYPE_ICON',
                                item.personal ? PROOF_MAP_CLIENT.personalIcon : PROOF_MAP_CLIENT.compterIcon) : '');
                if (!((proofType === 'error' || proofType === 'doubt') && item.term)) {
                    html = html.replace('$TYPE_REMARK', item.remark || '')
                        .replace('$TYPE_DISPLAY_REMARK', 'block');
                } else {
                    html = html.replace('$TYPE_DISPLAY_REMARK', 'none');
                }
                if (item.linkIds.length === 1) {
                    html = html.replace('$LINK_ID', item.linkIds[0] || '').replace('$PROOF_MORE_TEXT_HTML', '').replace('$PROOF_OP', PROOF_MAP_CLIENT.opHtml).replace('$PROOF_OP_ID', item.linkIds[0] || '');
                } else {
                    html = html.replace('$PROOF_MORE_TEXT_HTML', PROOF_MAP_CLIENT.itemMoreTextHtml.replace('$PROOF_MORE_TEXT_HTML', item.linkIds.map((v, i) => `<span style="color: #333;text-decoration: none" data-target="#${v}">第${i + 1}处</span>&nbsp;&nbsp;`).join(''))).replace('$PROOF_OP', '');
                }
                typeHtmlObj[proofType].push(html);
            });

            let proofHtml = Object.values(typeHtmlObj).map(v => v.join('')).join('');

            let titleHtml = Object.keys(typeObj).map(key => {
                const value = typeObj[key];
                return PROOF_MAP_CLIENT.titleHTMLTpl.replace('$TYPE_COLOR', PROOF_MAP_CLIENT[`${key}Color`])
                    .replace('$TYPE_ICON', PROOF_MAP_CLIENT[`${key}Icon`])
                    .replace('$TYPE_NUM', value.length);
            }).join('');

            if (!withStyle) {
                proofHtml = util.removeStyleAttr(proofHtml);
                titleHtml = util.removeStyleAttr(titleHtml);
            }

            const wordMap = {};
            Object.values(typeObj).forEach(w => {
                w.forEach(v => {
                    v.linkIds.forEach(k => {
                        wordMap[k] = v;
                    });
                });
            });

            return {
                content: orgContent,
                doubtList: typeObj.doubt,
                tempWordList: typeObj.tempWord,
                errorList: typeObj.error,
                wordMap,
                titleHtml,
                proofHtml
            };
        },
        formatProofTextClient (text, arr, key, filterString) {
            let posLimit = text.length + 1;
            arr = util.deepCopy(arr);
            arr.sort((a, b) => a.pos === b.pos ? a.end_pos - b.end_pos : (a.end_pos === b.end_pos ? b.pos - a.pos : a.pos - b.pos));
            const result = [];
            for (let index = arr.length; index > 0; index--) {
                let item = arr[index - 1];
                // if (filterString.length && !filterString.includes(item.label)) {
                if (filterString.length && !util.isType(filterString, item.label)) {
                    continue;
                }
                if (item.pos > -1 && item.end_pos && item.end_pos <= posLimit) {
                    let temp1 = text.slice(0, item.pos);
                    let temp2 = text.slice(item.pos, item.end_pos);
                    let temp3 = text.slice(item.end_pos);
                    let newTemp;

                    if (item.error_type === 'CONTAIN_HINT' || item.error_type === 'TYPO' || (item.label && item.label.includes('PRIVACY'))) {
                        newTemp = '<span id="' + item.linkId + '" data-type="' + item.error_type + '" class="common-proof-word-item common-proof-doubt" style="display: inline-block; background-color: ' + PROOF_MAP_CLIENT.doubtBgColor + '">' + temp2 + '</span>';
                    } else if (item.error_type === 'CONTAIN_TEMP_TAG') {
                        newTemp = '<span id="' + item.linkId + '" data-type="' + item.error_type + '" class="common-proof-word-item common-proof-tempWord" style="display: inline-block;background-color: ' + PROOF_MAP_CLIENT.tempBgWordColor + '">' + temp2 + '</span>';
                    } else {
                        newTemp = '<span id="' + item.linkId + '" data-type="' + item.error_type + '" class="common-proof-word-item common-proof-error" style="display: inline-block;background-color: ' + PROOF_MAP_CLIENT.errorBgColor + '">' + temp2 + '</span>';
                        // if (item.term) {
                        //     newTemp += '<span class="common-proof-correct" style="color: ' + PROOF_MAP.termColor + '">(' + item.term + ')</span>';
                        // }
                    }
                    text = temp1 + newTemp + temp3;
                    posLimit = item.pos;
                    item.pos += key;
                    result.push(item);
                }
            }
            text = text.replace(/\n/g, '<br>');
            return {text, result};
        },
        isType(filterString, label) {
            let filterArr = filterString.split(',');
            let flag = false;
            filterArr.forEach(item => {
                if (item === label) {
                    flag = true;
                    return;
                }
            });
            return flag;
        },
        readyToDocx (text, result) {
            text = injection.util.deepCopy(text);
            result = injection.util.deepCopy(result);
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    try {
                        let {content} = injection.util.changeProofData(text, result);
                        let html = ``;
                        content.forEach((txt) => {
                            html += `<p>${txt}</p>`;
                        });
                        resolve(html);
                    } catch (e) {
                        reject(e);
                    }
                });
            });
        },
        exportHTML (html, filename) {
            html = `<!DOCTYPE html>
                <html xmlns:o='urn:schemas-microsoft-com:office:office'
                      xmlns:w='urn:schemas-microsoft-com:office:word'
                      xmlns:dt='uuid:C2F41010-65B3-11d1-A29F-00AA00C14882'
                      xmlns='http://www.w3.org/TR/REC-html40'>
                        <head><meta charset='utf-8'><title>${filename}</title></head><body>${html}</body></html>`;

            var fileDownload = document.createElement('a');
            document.body.appendChild(fileDownload);
            fileDownload.href = `data:application/vnd.ms-word;charset=utf-8,${encodeURIComponent(html)}`;
            fileDownload.download = filename;
            fileDownload.click();
            document.body.removeChild(fileDownload);
        },
    };

    util.validate = util.validator();

    util = Object.assign(util, props);

    Object.defineProperties(injection, {
        util: {
            get () {
                return util;
            }
        }
    });
    Object.defineProperties(Vue.prototype, {
        $util: {
            get () {
                return util;
            }
        }
    });
}
